<template>
    <CForm :ref="componentName">
        <CInput
            :value.sync="$v.formDataComponent.name.$model"
            :label="$t('name')"
            name="name"
            :placeholder="$t('Enter the name')"
            :invalidFeedback="$t('Name is required')"
            size="sm"
        />
        <CTextarea
            :value.sync="$v.formDataComponent.description.$model"
            :label="$t('description')"
            name="description"
            :placeholder="$t('Enter the description')"
            :invalidFeedback="$t('Description is required')"
            size="sm"
        />
    </CForm>
</template>

<script>
/** Mixins */

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators"

export default {
    name: "GeneralSegmentForm",
    mixins: [validationMixin],
    data() {
        return {
            formDataComponent: {
                name: null,
                description: null,
            },
            _loading: false,
        };
    },
    props: {
        formData: {
            type: Object,
        },
        loading: Boolean,
    },
    computed: {
        componentName() {
            return this.$options.name;
        },
    },
    watch: {
        formData() {
            this.formDataComponent = this.formData;
        },
    },
    validations: {
        formDataComponent: {
            name: {
                required,
            },
            description: {
                required,
            }
        },
    },
    methods: {
        getFormData() {
            const form = this.$refs[this.componentName];
            const formData = new FormData(form);
            let data = Object.fromEntries(formData.entries());
            for (const key in data) {
                if (Object.prototype.hasOwnProperty.call(data, key)) {
                    if (data[key] == "") {
                        data[key] = null;
                    } else if (data[key] == "on") {
                        data[key] = true;
                    } else if (data[key] == "off") {
                        data[key] = false;
                    }
                }
            }
            return data;
        },
    },

    mounted() {
        this.formDataComponent = this.formData;
    },
};
</script>

<style></style>
